import React from 'react'
import { object, string, bool } from 'prop-types'
import changeFileExtension from '@/lib/filename-extension-modifier'
import { EventWOFSplitHero } from '@/component/Primitive/Events'

const EventWOFSplitHeroWidget = (props) => {
  const { images } = props
  const getImage = (context, ratio, size) =>
    images?.[`${context}_${ratio}_${size}`]?.[0]
  const largeSrcSet = [
    {
      width: 720,
      src: changeFileExtension(
        getImage('desktop_background', '16x9', 720)?.url,
        'webp'
      )
    },
    {
      width: 1440,
      src: changeFileExtension(
        getImage('desktop_background', '16x9', 1440)?.url,
        'webp'
      )
    }
  ]
  const smallSrcSet = [
    {
      width: 320,
      src: changeFileExtension(
        getImage('mobile_background', '16x9', 320)?.url,
        'webp'
      )
    },
    {
      width: 640,
      src: changeFileExtension(
        getImage('mobile_background', '16x9', 640)?.url,
        'webp'
      )
    }
  ]

  const image = {
    desktop: {
      srcSet: largeSrcSet,
      alt: 'Event WOF Placeholder',
      sizes: ['min-width(960px) 50vw', '100vw'],
      src: getImage('desktop_background', '16x9', 720)?.url
    },
    mobile: {
      srcSet: smallSrcSet,
      alt: 'Event WOF Placeholder',
      sizes: ['min-width(960px) 50vw', '100vw'],
      src: getImage('mobile_background', '16x9', 320)?.url
    }
  }
  return <EventWOFSplitHero {...props} image={image} />
}

EventWOFSplitHeroWidget.propTypes = {
  images: object,
  title: string,
  subtitle: string,
  description: string,
  ctaLabel: string,
  ctaLink: string,
  inverse: bool,
  theme: string
}

export default EventWOFSplitHeroWidget
